"use client";

import React, { useEffect, useState, useRef } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Shield, ChevronDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DetDigitaleFort() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="det-digitale-fort" className="dark relative h-screen min-h-[800px] w-full overflow-hidden bg-background text-foreground flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0 w-full h-[120%] -top-[10%]" style={{
      transform: `translateY(${scrollY * 0.3}px)`,
      willChange: "transform"
    }}>
        <div className="absolute inset-0 bg-background/60 z-10 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-transparent to-background/90 z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556341/img/dark_concrete_fortress_wall.png" alt="Tekstureret betonvæg" className="w-full h-full object-cover opacity-60 grayscale-[20%] contrast-125" />
      </div>

      {}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-20 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556341/img/noise_texture_overlay.png')] mix-blend-overlay" />

      {}
      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="mb-8 text-primary opacity-80">
          <Shield className="w-12 h-12 stroke-[1.5]" />
        </div>

        {}
        <h1 className="font-serif text-5xl md:text-7xl lg:text-9xl font-bold tracking-tighter uppercase mb-6 relative">
          <span className="relative z-10 drop-shadow-[0_0_25px_var(--primary)] text-foreground">
            Christian Bak
          </span>
          <span className="block text-2xl md:text-4xl lg:text-5xl mt-2 tracking-widest text-primary/80">
            Det Digitale Fort
          </span>
        </h1>

        {}
        <div className="max-w-3xl mb-12 space-y-6">
          <p className="font-sans text-lg md:text-2xl text-foreground leading-relaxed border-l-4 border-primary pl-6 font-bold uppercase tracking-tight">
            Samfund & Moral • Disciplin & Karakterstyrke • Tro & Eksistens
          </p>
          <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed text-justify">
            Her i Det Digitale Fort dikteres dagsordenen ikke af tidsåndens luner, men af urokkelige principper. 
            Som fundament for min <span className="text-foreground font-semibold">samfundsdebat</span> trækker jeg på min baggrund med <span className="text-foreground font-semibold">militær disciplin</span> 
            og en kompromisløs <span className="text-foreground font-semibold">kristen etik</span>. Dette er Christian Baks opgør med hykleri; 
            en platform dedikeret til <span className="text-foreground font-semibold">karakterdannelse</span> og det ultimative <span className="text-foreground font-semibold">personligt ansvar</span>. 
            Vi bygger et intellektuelt værn, hvor sandheden står alene mod mængden.
          </p>
        </div>

        {}
        <div className="flex flex-col sm:flex-row gap-6 items-center">
          <Button asChild className="h-16 px-10 text-lg font-serif tracking-widest uppercase border-2 border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 rounded-none shadow-[0_0_15px_rgba(0,0,0,0.5)] hover:shadow-[0_0_25px_var(--primary)]">
            <Link to="/JourneyPage">Indtag Frontlinjen</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 animate-bounce text-muted-foreground/50">
        <ChevronDown className="w-8 h-8" />
      </div>
    </section>;
}